import * as React from 'react'

import Drawer from '@components/drawer/Drawer'

import MobileScreen from './LoginScreenMobile'
import WebScreen from './LoginScreenWeb'

import useBreakpoint from '@utils/useBreakpoints'

const LoginScreen = () => {
  const [, bp] = useBreakpoint()

  React.useEffect(() => {
    Drawer.close()
  }, [bp])

  return bp === 'phone' ? <MobileScreen /> : <WebScreen />
}

export default LoginScreen
